// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"174":"9b459f51","590":"f8544301","641":"2a18fc22"}[chunkId] + ".js";
};